<template>
  <v-container>
    <v-col v-if="registroSelecionado != null">
      <v-data-table
        :headers="headers"
        :items="registroSelecionado.registroVersao"
        :search="search"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
      >
        <template v-slot:item.validado="{ item }">
          {{
            item.validado != null
              ? item.validado
                ? item.exclusao
                  ? "Excluído"
                  : "Aprovado"
                : "Reprovado"
              : "Não Analisado"
          }}
        </template>
        <template v-slot:item.usuarioValidacao="{ item }">
          {{
            item.usuarioValidacao
              ? `${item.usuarioValidacao.nome} - Id ${item.usuarioValidacao.id}`
              : "Não Analisado"
          }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            color="error"
            fab
            x-small
            class="mr-2"
            dark
            title="Inativar registro"
            :disabled="item.validado != null"
            @click="inativarRegistro(item.id)"
            ><v-icon>mdi-trash-can</v-icon></v-btn
          >
          <v-btn
            color="primary"
            fab
            x-small
            dark
            @click="buscarRegistroVersao(item.id)"
            title="Exibir anexos"
            ><v-icon>mdi-eye</v-icon></v-btn
          >
          <v-btn
            color="green"
            title="Exibir observação"
            fab
            class="ml-2"
            x-small
            :disabled="!item.observacoes"
            dark
            @click="exibirObservacao(item)"
            ><v-icon v-if="rowIsExpanded(item)">mdi-arrow-expand-up</v-icon>
            <v-icon v-else>mdi-arrow-expand-down</v-icon>
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td
            :colspan="headers.length"
            style="white-space: pre-line; padding: 1rem"
          >
            {{ item.observacoes?.replace(/ /gm, "\xa0") }}
          </td>
        </template>
      </v-data-table>
      <div v-if="buscandoRegistroVersao === false">
        <div v-if="anexos.length > 0">
          <h5>Anexos</h5>
          <p v-for="anexo in anexos" :key="anexo.id">
            <v-btn
              @click="
                anexo.extensao.toLowerCase() === 'pdf'
                  ? exibirPDF(anexo)
                  : exibirPDF(anexo)
              "
              color="primary"
            >
              <v-icon class="mr-2">fas fa-file</v-icon>
              {{ anexo.nomeArquivoOriginal }}
            </v-btn>
          </p>
        </div>
      </div>
      <div v-else><h5>Carregando...</h5></div>
    </v-col>
    <ModalDialogVisualizacaoImg
      :imgFile="imgExibir"
      :visivel="dialogFullScreen"
      @close="fecharImg"
    />
    <ModalDialogVisualizacaoPdf
      :visivel="dialogPDF"
      :pdfFile="pdfExibir"
      @close="fecharPDF()"
    />
  </v-container>
</template>

<script>
import ApiService from "@/common/services/http/api.service";
import SweetAlert from "@/common/services/sweetalert.service";
import "vue-pdf-app/dist/icons/main.css";
import Swal from "sweetalert2";
import ModalDialogVisualizacaoPdf from "./Visualisador/ModalDialogVisualizacaoPdf.vue";
import ModalDialogVisualizacaoImg from "./Visualisador/ModalDialogVisualizacaoImg.vue";

export default {
  name: "historico-registro",
  props: ["registroSelecionado"],
  watch: {
    registroSelecionado: function (newVal, oldVal) {
      newVal;
      oldVal;
      this.registroVersao = null;
      this.anexos = [];
      this.expanded = [];
    },
  },
  data() {
    return {
      dialogPDF: false,
      search: "",
      headers: [
        { text: "Status", value: "validado", width: "8%" },
        { text: "Criado Por", value: "criadoPor" },
        { text: "Anexado Por", value: "usuariosUpload", width: "8%" },
        { text: "Data Anexo", value: "dataUploadExibicao", width: "8%" },
        { text: "Excluído Por", value: "usuariosExclusao" },
        { text: "Data Exclusão", value: "dataExclusaoExibicao", width: "8%" },
        { text: "Validado Por", value: "usuarioValidacao" },
        { text: "Data Validação", value: "dataValidacaoExibicao", width: "8%" },
        { text: "", value: "actions", align: "end" },
      ],
      buscandoRegistroVersao: false,
      anexos: [],
      pdfExibir: {},
      imgExibir: {},
      dialogFullScreen: false,
      urlCaminhoExibir: null,
      singleExpand: false,
      expanded: [],
      registroVersao: null,
    };
  },
  components: {
    ModalDialogVisualizacaoPdf,
    ModalDialogVisualizacaoImg,
  },
  methods: {
    pagesRenderedHandler(pdfApp) {
      setTimeout(() => {
        pdfApp.pdfViewer.currentScaleValue = 1; // 100%;
      });
    },
    async exibirPDF(pdf) {
      if (!pdf) {
        this.dialogPDF = false;
        return;
      }
      if (pdf.extensaoID > 2) {
        window.open(pdf.caminhoVisualizacao, "_blank");
        return;
      }
      // const url = await this.getPDF(pdf.caminhoVisualizacao);
      this.pdfExibir = pdf;
      this.dialogPDF = true;
    },

    async getPDF(file) {
      try {
        return file;
        // const dados = await fetch(file);
        // const blobPDF = await dados.arrayBuffer();
        // console.log(blobPDF);
        // return URL.createObjectURL(blobPDF);
      } catch {
        return "";
      }
    },
    fecharPDF() {
      this.pdfExibir = {};
      this.dialogPDF = false;
    },

    async buscarRegistroVersao(idRegistroVersao) {
      if (idRegistroVersao == this.registroVersao?.id) return;
      this.buscandoRegistroVersao = true;

      const { data: result } = await ApiService.get(
        `RegistroVersao/GetRegistroVersaoById/${idRegistroVersao}`
      );

      if (result.success) {
        this.registroVersao = result.data;

        this.anexos = result.data.registroImagem;
      } else SweetAlert.sweetAlertError(result.errors);

      this.buscandoRegistroVersao = false;
    },

    async inativarRegistro(registroID) {
      let self = this;
      Swal.fire({
        title: "Remover arquivo",
        text: "Tem certeza que deseja remover o arquivo? Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode remover!",
      }).then(async function (result) {
        if (result.value) {
          self.buscandoRegistroVersao = true;

          const { data: result } = await ApiService.put(
            `RegistroVersao/${registroID}/Inativar`
          );

          if (result.success) {
            self.$emit("inativar-registro", { success: result.success });
          } else SweetAlert.sweetAlertError(result.errors);

          self.buscandoRegistroVersao = false;
        }
      });
    },

    rowIsExpanded(item) {
      return this.expanded.includes(item);
    },
    exibirObservacao(item) {
      if (this.rowIsExpanded(item)) {
        this.expanded = [];
        return;
      }
      this.expanded.push(item);
    },

    downloadFile(url) {
      window.open(url);
    },

    exibirImagem(img) {
      if (!img) {
        this.dialogFullScreen = false;
        return;
      }
      this.imgExibir = img;
      this.dialogFullScreen = true;
    },
    fecharImg() {
      this.imgExibir = {};
      this.dialogFullScreen = false;
    },
  },
};
</script>
<style>
.dialogPDF {
  width: 100%;
  overflow: hidden;
}
</style>
